import type { BreadcrumbItem } from "@/lib/breadcrumbs";

export function PageBreadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav className="container-page pt-4 text-xs text-muted-foreground" aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <span key={item.path}>
            {index > 0 && <span className="mx-1.5">/</span>}
            {!isLast ? (
              <a href={item.path} className="hover:text-accent">
                {item.label}
              </a>
            ) : (
              <span className="text-foreground">{item.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
